<template>
    <div>
        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>模具整备列表</b></p>

            <div style="display:inline-block">
                <el-radio-group v-model="statusSearch" @input="searchByStatus">
                    <el-radio-button label="0">待整备</el-radio-button>
                    <el-radio-button label="1">已整备</el-radio-button>
                    <el-radio-button label="2">已确认</el-radio-button>
                    <el-radio-button label="3">闲置中</el-radio-button>

                    <el-radio-button label="-1">全部</el-radio-button>
                </el-radio-group>
            </div>

            <div style="display:inline-block;width: 300px;">
                <el-input placeholder="请输入模具编号" v-model="queryValue" class="input-with-select">
                    <el-button slot="append" icon="el-icon-search" @click="searchOrder"></el-button>
                </el-input>
            </div>
        </div>

        <el-table :data="moldList" style="width: 100%" @select="selectClick" @row-click="rowClick" ref="plasticTable"
            highlight-current-row :row-class-name="tableRowClassName">
            <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
            </el-table-column>

            <el-table-column prop="moldCode" label="模具编号" min-width="14%">
            </el-table-column>

            <el-table-column prop="preparer" label="整备人员" min-width="10%">
            </el-table-column>
            <el-table-column prop="completeTime" label="整备完成时间" min-width="15%">
            </el-table-column>

            <el-table-column prop="checker" label="审核人员" min-width="10%">
            </el-table-column>
            <el-table-column prop="checkTime" label="审核时间" min-width="15%">
            </el-table-column>
            <el-table-column prop="status" label="状态" min-width="10%">
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="16%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="success" round size="small">
                        查看
                    </el-button>
                    <el-button @click="topClick(scope.row)" type="danger" round size="small">
                        置顶
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount" layout="total, sizes, prev, pager, next"
                :total="total" @current-change="pageClick" :page-sizes="[6, 10, 14, 18]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <el-dialog title="备模详情" :visible.sync="dlgFormVisible" width="60%">
            <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">
                <el-form-item label="模具编号" required :label-width="formLabelWidth">
                    <el-input v-model="form.moldCode" autocomplete="off" style="width:220px" disabled></el-input>
                </el-form-item>

                <el-form-item label="整备人员" :label-width="formLabelWidth" prop="preparer">
                    <el-input v-model="form.preparer" autocomplete="off" style="width:220px" disabled></el-input>
                </el-form-item>

                <el-form-item label="整备完成时间" :label-width="formLabelWidth" prop="completeTime">
                    <el-date-picker v-model="form.completeTime" type="date" placeholder="选择日期" disabled>
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="审核时间" :label-width="formLabelWidth" prop="checkTime">
                    <el-date-picker v-model="form.checkTime" type="date" placeholder="选择日期" disabled>
                    </el-date-picker>
                </el-form-item>

                <div style="width:350px;display: inline-block;"></div>

                <el-form-item label="备注" :label-width="formLabelWidth">
                    <el-input v-model="form.remark" autocomplete="off" type="textarea" style="width:570px"
                        disabled></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dlgFormVisible = false">取 消</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import Sortable from 'sortablejs'

export default {
    name: "MoldPrepare",
    data() {
        return {
            dPath:this.getDefaultPath(),
            token: this.getToken(),
            companyId: this.getCompanyId(),
            userId: this.getUserId(),

            moldList: [],
            dlgFormVisible: false,

            statusSearch: 0,
            queryValue: '',

            form: {
                id: '',
                moldCode: '',

                preparer: '',

                completeTime: new Date(),
                checkTime: '',
                status: 0,
                remark: '',
            },

            loading: false,
            formLabelWidth: '120px',

            pageIndex: 0,
            pageNum: 6,
            total: 0,
            pageCount: 0,

            rules: {}
        }
    },
    methods: {
        searchOrder(query) {
            this.moldList = []

            if (this.queryValue !== '') {

                this.loading = true
                setTimeout(() => {
                    this.loading = false

                    this.getAll(this.statusSearch)
                }, 200)
            } else {
                this.$message({
                    type: 'info',
                    message: '请输入搜索条件'
                })
            }
        },
        selectClick(selection, row) {
            this.$refs.plasticTable.clearSelection()
            this.$refs.plasticTable.toggleRowSelection(row)
            this.form.moldCode = row.moldCode
        },
        rowClick(row) {
            //console.log(row)
            this.$refs.plasticTable.clearSelection()
            this.$refs.plasticTable.toggleRowSelection(row)
            this.form.moldCode = row.moldCode
        },
        handleClick(row) {
            // console.log(row)
            this.form.id = row.id

            this.form.moldCode = row.moldCode
            
            this.form.preparer = row.preparer

            this.form.completeTime = row.completeTime
            this.form.checkTime = row.checkTime
            this.form.status = null
            this.form.remark = row.remark

            this.dlgFormVisible = true
        },
        topClick(row) {
            this.$confirm('确定要置顶吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.topMold(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消置顶'
                })
            })
        },
        topMold(row) {

            this.$axios({
                method: "post",
                url: "/shiro/mold/prepare/top",
                data: {
                    id: row.id,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

            })
        },
        tableRowClassName({ row, rowIndex }) {
            if (row.toppingTime != null && row.toppingTime != '') {
                return 'warning-row'
            }
            return ''
        },
        searchByStatus(val) {
            //console.log('bbb')
            //console.log(val)
            this.getAll(val)
        },
        getAll(val) {

            this.$axios({
                method: "post",
                url: "/shiro/mold/prepare/getAll",
                data: {
                    companyId: this.companyId,
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    statusStr: val,
                    queryParam: this.queryValue
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.moldList = data.data
                this.total = 0
                this.total = this.moldList[0].total
                for (let i in this.moldList) {

                    var ml = this.moldList[i]

                    if (ml.completeTime) {
                        this.moldList[i].completeTime = this.$moment(ml.completeTime).format("YYYY-MM-DD")
                    } else {
                        this.moldList[i].completeTime = ''
                    }

                    if (ml.checkTime) {
                        this.moldList[i].checkTime = this.$moment(ml.checkTime).format("YYYY-MM-DD")
                    } else {
                        this.moldList[i].checkTime = ''
                    }

                    if (ml.status == 0) {
                        this.moldList[i].status = '待整备'
                    } else if (ml.status == 1) {
                        this.moldList[i].status = '已整备'
                    } else if (ml.status == 2) {
                        this.moldList[i].status = '已确认'
                    } else {
                        this.moldList[i].status = '闲置中'
                    }
                }
            })
        },
        pageClick(currentPage) {
            this.moldList = []

            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAll(this.statusSearch)
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAll(this.statusSearch)
        },
        //行拖拽
        rowDrop() {
            const tbodys = document.querySelectorAll('.el-table__body tbody')//[8]
            // console.log(tbodys)

            const tbody = document.body.querySelector('.el-table__body tbody')
            // console.log('tbody')
            // console.log(tbody)

            const _this = this
            // console.log('_this')
            // console.log(_this)

            Sortable.create(tbody, {
                onEnd({ newIndex, oldIndex }) {
                    if (newIndex == oldIndex) return

                    _this.moldList.splice(newIndex, 0, _this.moldList.splice(oldIndex, 1)[0])

                    var newArray = _this.moldList.slice(0)
                    // console.log('newArray')
                    // console.log(newArray)

                    _this.moldList = []

                    _this.$nextTick(function () {
                        _this.moldList = newArray

                        this.sort(newArray)
                    })

                }
            })

        },
        sort(val) {
            // console.log('sort()')
            if (val.length > 0) {

                for (let i in val) {
                    delete val[i].completeTime
                    delete val[i].checkTime
                    delete val[i].status
                }
            }
            // console.log('newVal')
            // console.log(val)

            this.$axios({
                method: "post",
                url: "/shiro/mold/prepare/sort",
                data: {
                    moldPrepareVOList: val,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

            })
        },
    },
    mounted() {
        console.log('MoldPrepare.vue--mounted()')
        this.setDefaultPath('/moldPrepare')
        // var dp=this.getDefaultPath()
        // console.log(dp)

        this.getAll(this.statusSearch)

        // 阻止默认行为
        document.body.ondrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };
        this.rowDrop()//行拖拽
    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-pagination__total {
    color: green;
}

.el-table .warning-row {
    background: oldlace;
}
</style>